export default {
  tabs: {
    online_shop: 'Boutique en ligne',
    reservations: 'Réservations',
    storefront: 'Vitrine',
  },
};
